<div class="app-content no-sidebar no-top-menu">
  <scrollbar>
    <div class="page-title">
      <h1>{{ t("contacts.title") }}</h1>
    </div>

    <!-- Контакты -->
    <div class="flex flex-wrap tablet:flex-nowrap gap-x-36 gap-y-8 mb-8">
      <div>
        <div class="mb-6">{{ t("contacts.text") }}</div>

        <div class="flex flex-col gap-4">
          <a href="https://t.me/glabix_support" target="_blank" class="flex items-center gap-2 link-hover-underline">
            <div class="flex-center-6 flex-shrink-0">
              <span class="i i--lg i-paper-plane-2 text-tg"></span>
            </div>
            <span class="link-hover-underline">{{ t("contacts.tg") }}</span>
          </a>
          <a href="mailto:hello@glabix.com" class="flex items-center gap-2 link-hover-underline">
            <div class="flex-center-6 flex-shrink-0">
              <span class="i i--lg i-envelope text-primary"></span>
            </div>
            <span class="link-hover-underline">hello&#64;glabix.com</span>
          </a>
        </div>
      </div>

      <div>
        <div class="mb-6">{{ t("subscribe.text") }}</div>

        <div class="flex flex-col gap-4">
          <a href="https://t.me/glabix" target="_blank" class="flex items-center gap-2 link-hover-underline">
            <div class="i-social-box text-tg flex-shrink-0">
              <div class="i i-paper-plane-2"></div>
            </div>
            <span class="link-hover-underline">{{ t("subscribe.tg") }}</span>
          </a>
          <a href="https://vk.com/public223050179" target="_blank" class="flex items-center gap-2 link-hover-underline">
            <div class="i-social-box text-vk flex-shrink-0">
              <div class="i i-vk"></div>
            </div>
            <span class="link-hover-underline">{{ t("subscribe.vk") }}</span>
          </a>
          <a href="https://glabix.com/blog" target="_blank" class="flex items-center gap-2 link-hover-underline">
            <div class="i-social-box glabix flex-shrink-0">
              <div class="i i-glabix-screen"></div>
            </div>
            <span class="link-hover-underline">{{ t("subscribe.gx") }}</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Баннер -->
    <div class="support-banner mb-8">
      <div class="text-2xl">
        <span class="text-black font-weight-300">Присоединяйтесь к </span>
        <span class="text-magenta-gradient font-bold">программе лояльности </span>
        <span class="text-magenta-gradient font-bold">Глабикс</span>
      </div>
      <div>
        <div class="text-xs text-black mb-5">
          Поделитесь видеосообщениями с коллегами и друзьями, получайте баллы с их подписки. Баллы можно потратить на
          оплату или вывести.
        </div>
        <a
          [routerLink]="['/org', currentOrganization.id, 'settings', 'loyalty-program']"
          class="btn btn--gradient text-white"
        >
          Подробнее
        </a>
      </div>
    </div>

    <!-- Глабикс.Экран -->
    <div class="page-title mb-8">
      <h2>{{ t("screen.title") }}</h2>
    </div>

    <div class="support-sections">
      <div *ngFor="let section of screenSections">
        <div class="font-bold mb-6">{{ section.title }}</div>
        <a
          *ngFor="let item of section.items"
          [href]="item.link"
          target="_blank"
          class="flex gap-3 link-hover-underline mb-5"
        >
          <div class="flex-center-6 flex-shrink-0">
            <span class="i i--lg i-glabix-screen text-magenta-gradient"></span>
          </div>
          <span class="pt-0.5 link-hover-underline">{{ item.text }}</span>
        </a>
      </div>
    </div>
    <div class="w-fit mx-auto">
      <a
        href="https://glabix.com/help/screen/chto-takoe-glabiks-ekran"
        target="_blank"
        class="btn btn--secondary mb-16"
      >
        {{ t("screen.readMore") }}
      </a>
    </div>

    <!-- Глабикс.Летучка -->
    <div class="page-title mb-8">
      <h2>{{ t("letuchka.title") }}</h2>
    </div>

    <div class="support-sections">
      <div *ngFor="let section of letuchkaSections">
        <div class="font-bold mb-6">{{ section.title }}</div>
        <a
          *ngFor="let item of section.items"
          [href]="item.link"
          target="_blank"
          class="flex gap-3 link-hover-underline mb-5"
        >
          <div class="flex-center-6 flex-shrink-0">
            <span class="i i--lg i-glabix-letuchka text-primary-gradient"></span>
          </div>
          <span class="pt-0.5 link-hover-underline">{{ item.text }}</span>
        </a>
      </div>
    </div>
    <div class="w-fit mx-auto">
      <a
        href="https://glabix.com/help/letuchka/chto-takoe-glabiks-letuchka"
        target="_blank"
        class="btn btn--secondary mb-16"
      >
        {{ t("letuchka.readMore") }}
      </a>
    </div>
  </scrollbar>
</div>
